import React, { useState } from 'react';

const Feedback: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    rating: '',
    feedback: '',
    improvements: '',
    recommend: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Feedback submitted:', formData);
    alert('Thank you for your feedback! Your input helps us improve Flow.');
    setFormData({
      name: '',
      email: '',
      category: '',
      rating: '',
      feedback: '',
      improvements: '',
      recommend: ''
    });
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Your Feedback Matters</h1>
        <p className="page-subtitle">Help us make Flow better for everyone</p>
      </div>

      <div className="page-content">
        <section className="content-section">
          <h2>We Value Your Opinion</h2>
          <p>
            Your feedback is incredibly valuable to us. It helps us understand what's working well
            and what we can improve. Whether you have suggestions, found a bug, or just want to
            share your experience, we want to hear from you.
          </p>
        </section>

        <form className="feedback-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name (Optional)</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email (Optional)</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
              />
              <small>Only if you'd like a response from us</small>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="category">What type of feedback is this? *</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              required
            >
              <option value="">Select a category</option>
              <option value="bug-report">Bug Report</option>
              <option value="feature-request">Feature Request</option>
              <option value="user-experience">User Experience</option>
              <option value="performance">Performance</option>
              <option value="design">Design & Interface</option>
              <option value="general">General Feedback</option>
              <option value="compliment">Compliment</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="rating">How would you rate your overall experience with Flow? *</label>
            <select
              id="rating"
              name="rating"
              value={formData.rating}
              onChange={handleInputChange}
              required
            >
              <option value="">Select a rating</option>
              <option value="5">⭐⭐⭐⭐⭐ Excellent</option>
              <option value="4">⭐⭐⭐⭐ Very Good</option>
              <option value="3">⭐⭐⭐ Good</option>
              <option value="2">⭐⭐ Fair</option>
              <option value="1">⭐ Poor</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="feedback">Your Feedback *</label>
            <textarea
              id="feedback"
              name="feedback"
              rows={5}
              value={formData.feedback}
              onChange={handleInputChange}
              placeholder="Tell us about your experience, what you like, what could be better, or any issues you've encountered..."
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="improvements">What specific improvements would you like to see?</label>
            <textarea
              id="improvements"
              name="improvements"
              rows={3}
              value={formData.improvements}
              onChange={handleInputChange}
              placeholder="Describe any features, changes, or improvements you'd like to see in Flow..."
            />
          </div>

          <div className="form-group">
            <label htmlFor="recommend">Would you recommend Flow to others?</label>
            <select
              id="recommend"
              name="recommend"
              value={formData.recommend}
              onChange={handleInputChange}
            >
              <option value="">Select an option</option>
              <option value="definitely">Definitely</option>
              <option value="probably">Probably</option>
              <option value="not-sure">Not sure</option>
              <option value="probably-not">Probably not</option>
              <option value="definitely-not">Definitely not</option>
            </select>
          </div>

          <button type="submit" className="submit-button">
            Submit Feedback
          </button>
        </form>

        <section className="content-section">
          <h2>Other Ways to Share Feedback</h2>
          <div className="feedback-alternatives">
            <div className="feedback-option">
              <h3>Quick Survey</h3>
              <p>Take our 2-minute survey to share your thoughts on specific features.</p>
            </div>
            <div className="feedback-option">
              <h3>Community Forum</h3>
              <p>Join discussions with other Flow users and share ideas for improvements.</p>
            </div>
            <div className="feedback-option">
              <h3>Beta Testing</h3>
              <p>Get early access to new features and help us test them before they're released.</p>
            </div>
          </div>
        </section>

        <section className="content-section">
          <h2>Thank You!</h2>
          <p>
            Every piece of feedback helps us create a better writing experience for everyone.
            Your input directly influences our development priorities and helps us build
            features that matter most to our users.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Feedback;